import Cookies from 'js-cookie';

export const clearAuthSessionCookies = async (): Promise<void> => {
  Object.keys(Cookies.get()).forEach((key) => {
    if (key.startsWith('appSession') || key.startsWith('__session')) {
      Cookies.remove(key);
    }
  });
};
